import React from 'react';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { activateBookmark } from '../../../../redux/bookmark/Actions';
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography, Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseRounded';
import HomeIcon from '@material-ui/icons/Home';
import CreateView from './CreateView';
import EditView from './EditView';
import RemoveView from './RemoveView';
import { Skeleton } from '@material-ui/lab';
import { setOrCreateNewActiveLayers } from '../../../../redux/active_layers/Actions';
import { removeAllLayers } from '../../../../redux/active_layers/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import DeleteIcon from '@material-ui/icons/Delete';

class ViewBase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createOpen: false,
            editOpen: false,
            removeOpen: false,
            editingBookmark: null,
            removingBookmark: null,
            loading: false,
            visibleBookmarkIndex: -1,
            bookmarkIndexes: []
        };
    }

    componentDidMount() {
        const { homeBookmarkId } = this.props;
        const filteredBookmarks = [
            homeBookmarkId,
            ...this.props.bookmarks
                .filter(b => b && b.id !== homeBookmarkId)
                .map(b => b.id)
        ];
        if (!_.isEqual(filteredBookmarks, this.state.bookmarkIndexes)) {
            this.setState({
                bookmarkIndexes: filteredBookmarks
            });
        }
    }

    componentDidUpdate(nextProps, nextState) {
        const { homeBookmarkId } = this.props;
        const filteredBookmarks = [
            homeBookmarkId,
            ...this.props.bookmarks
                .filter(b => b && b.id !== homeBookmarkId)
                .map(b => b.id)
        ];
        if (!_.isEqual(filteredBookmarks, this.state.bookmarkIndexes)) {
            this.setState({
                bookmarkIndexes: filteredBookmarks
            });
        }
    }

    render() {
        const {
            classes,
            layers,
            bookmarks,
            homeBookmarkId,
            fetchLoading,
            bookmarkLoading,
            drawModule,
            dispatchActivateBookmark,
            dispatchRemoveAllActiveLayers,
            dispatchSetNewActiveLayers
        } = this.props;
        const {
            createOpen,
            editOpen,
            editingBookmark,
            visibleBookmarkIndex,
            removingBookmark,
            removeOpen
        } = this.state;
        return (
            <div className={classes.root}>
                <CreateView
                    open={createOpen}
                    onClose={e => this.setState({ createOpen: false })}
                />
                {editingBookmark && editOpen && (
                    <EditView
                        open={editOpen}
                        bookmark={editingBookmark && { ...editingBookmark }}
                        onClose={e => this.setState({ editOpen: false })}
                        editBookmark={val =>
                            this.setState({
                                editingBookmark: val
                            })
                        }
                        openRemoveBookmark={bookmark => {
                            this.setState({
                                editOpen: false,
                                removeOpen: true,
                                removingBookmark: bookmark
                            });
                        }}
                    />
                )}
                <RemoveView
                    open={removeOpen}
                    onClose={e => this.setState({ removeOpen: false })}
                    bookmark={removingBookmark}
                />
                <div className={classes.header}>
                    <Typography
                        className={classes.headerText}
                        variant="h4"
                        color="textPrimary"
                        component="div">
                        My Views
                    </Typography>
                </div>
                <div className={classes.body}>
                    <div className={classes.views}>
                        {bookmarks.map(
                            (b, i) =>
                                b && (
                                    <div
                                        key={i}
                                        className={`${classes.view} ${
                                            visibleBookmarkIndex === i &&
                                            classes.visible
                                        } ${classes.cursorPointer}`}
                                        onMouseOver={e =>
                                            this.setState({
                                                visibleBookmarkIndex: i
                                            })
                                        }
                                        onClick={e => {
                                            const editButton =
                                                document.getElementById(`edit-${i}`);
                                            if (e.target !== editButton) {
                                                // remove any active layers before going to view
                                                dispatchRemoveAllActiveLayers();
                                                if (b.selectedLayers) {
                                                    const activeLayers =
                                                        b.selectedLayers.map(e => ({
                                                            uid: e.systemName,
                                                            systemName: e.systemName,
                                                            visible: true,
                                                            printable: true
                                                        }));
                                                    dispatchSetNewActiveLayers(
                                                        activeLayers,
                                                        layers
                                                    );
                                                }
                                                dispatchActivateBookmark(b);
                                            }
                                        }}>
                                        <Box display="flex">
                                            {homeBookmarkId === b.id && (
                                                <HomeIcon
                                                    className={`${classes.silver}`}
                                                    fontSize="small"
                                                />
                                            )}
                                            <Typography
                                                color="textPrimary"
                                                variant="body2"
                                                className={classes.viewName}>
                                                {b.name}
                                            </Typography>
                                        </Box>
                                        <div className={classes.rightView}>
                                            {visibleBookmarkIndex === i && (
                                                <Box
                                                    display="flex"
                                                    alignItems="center">
                                                    <Typography
                                                        id={`edit-${i}`}
                                                        component="div"
                                                        color="textPrimary"
                                                        variant="caption"
                                                        className={`${classes.cursorPointer} ${classes.edit}`}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            this.setState({
                                                                editOpen: true,
                                                                editingBookmark: {
                                                                    ...b
                                                                }
                                                            });
                                                        }}>
                                                        edit
                                                    </Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            this.setState({
                                                                editOpen: false,
                                                                removeOpen: true,
                                                                removingBookmark: b
                                                            });
                                                        }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </div>
                                    </div>
                                )
                        )}
                    </div>
                    <div className={classes.save}>
                        <Button
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            onClick={e => this.setState({ createOpen: true })}>
                            SAVE CURRENT VIEW
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        background: theme.palette.background.main,
        width: '250px',
        borderRadius: '6px',
        position: 'absolute',
        right: '-250px'
    },
    header: {
        height: '45px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 20px',
        backgroundColor: theme.palette.background.dark,
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px'
    },
    views: {
        ...theme.components.scrollable,
        borderBottom: '1px solid ' + theme.palette.grey.variant3,
        maxHeight: '300px',
        overflow: 'auto'
    },
    view: {
        padding: '0 0.75rem',
        height: '38px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    viewName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    rightView: {
        display: 'flex',
        columnGap: '10px',
        alignItems: 'center'
    },
    body: {},
    save: {
        padding: '10px 20px'
    },
    silver: {
        fill: theme.palette.secondary.light,
        marginRight: '0.25rem'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    edit: {
        cursor: 'pointer',
        color: theme.palette.grey.variant4
    },
    loadingSpinner: {
        // height: '80px',
        // display: 'grid',
        // placeItems: 'center'
        height: '38px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 10px'
    },
    spinner: {
        // height: ''
    },
    visible: {
        backgroundColor: 'rgba(140, 151, 153, 0.2);'
    }
});

const mapStateToProps = state => ({
    bookmarks: state.bookmarkReducer.bookmarks,
    homeBookmarkId: state.bookmarkReducer.homeBookmarkId,
    fetchLoading: state.bookmarkReducer.isFetchingbookmarks,
    bookmarkLoading: state.bookmarkReducer.loading,
    layers: state.layers.layers,
    drawModule: state[MAIN_MAP].drawModule
});

const mapDispatchToProps = dispatch => ({
    dispatchRemoveAllActiveLayers: () => dispatch(removeAllLayers()),
    dispatchActivateBookmark: bookmark => dispatch(activateBookmark(bookmark)),
    dispatchSetNewActiveLayers: (a, l) => dispatch(setOrCreateNewActiveLayers(a, l))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(ViewBase);
